define([], function() {
  'use strict';
  return {
    assets: {
      image: '/v1.0/compCheck/{comp_check_id}/v{version}/image/{comp_check_image}',
      audio: '/v1.0/compCheck/{comp_check_id}/v{version}/audio/{comp_check_audio}',
      commonData: '/v1.0/{comp_check_common_data}'
    }
  };
});
